import { render } from "./ScaleData.vue?vue&type=template&id=4afa84a6"
import script from "./ScaleData.vue?vue&type=script&lang=js"
export * from "./ScaleData.vue?vue&type=script&lang=js"

import "./ScaleData.vue?vue&type=style&index=0&id=4afa84a6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__